import React, { useEffect, useState } from "react";
import { FaRecycle } from "react-icons/fa6";
import { IoIosWarning } from "react-icons/io";
import { FaCheckCircle, FaTimes } from "react-icons/fa";
import { MdOutlineAssessment } from "react-icons/md";
import { Link } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import { LuShare2 } from "react-icons/lu";
import { FaLink } from "react-icons/fa";
import {
  Popover,
  Box,
  SpeedDial,
  SpeedDialAction,
  Menu,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import { useIsMobile } from "../../../utilities";
import { FaWhatsapp, FaEnvelope, FaCopy, FaShareAlt } from "react-icons/fa";
import SpecificVehicleTypeChart from "./SpecificvehicleTypeChart";
import AddExpenseModal from "../../Expense/AddExpenseModal";
import AddCashFlowModal from "../../Cashflow/AddCashFlowModal";
import { toast } from "react-toastify";
import {
  getUserTodayBillibgDashboardApi,
  getWhatsAppReportDashboardApi,
} from "../../../services/DashboardService";
import { Spinner } from "react-bootstrap";
import { formatToIndianNumber, paymentStatusBadge } from "../../../utilities";
import { format } from "date-fns";
import ProfitLossCard from "../AdminDashboard.js/MonthlySmallProfitLosscard";
import UserTimeChart from "./UserTimeChart";
import UserServiceTypeChart from "./UserServiceTypeChart";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdFeedback } from "react-icons/md";
import { getUserServicecenterDeatailsApi } from "../../../services/UserService";
import { CustomTooltip } from "../../../components/CustomTooltip";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";
const UserDashboard = () => {
  const isMobile = useIsMobile();
  const [reportSummary, setReportSummary] = useState("");
  const [reportSummaryLoading, setReportSummaryLoading] = useState(false);
  const [userServiceCenter, setUserServiceCenter] = useState(null);

  //report summary param
  const [summaryParam, setSummaryParam] = useState({
    date: format(new Date(), "yyyy-MM-dd"),
  });

  //share popup
  const [shareLoactionOpen, setShareLoactionOpen] = useState(null);
  const locationOpen = Boolean(shareLoactionOpen);
  const handleLocationOpen = (event) =>
    setShareLoactionOpen(event.currentTarget);
  const handleLocationClose = () => setShareLoactionOpen(null);

  const handleLocationWhatsApp = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(
      `Check this location: ${userServiceCenter?.google_map_link || ""}`
    )}`;
    window.open(url, "_blank");
    handleLocationClose();
  };

  const handleLocationCopyLink = () => {
    navigator.clipboard.writeText(userServiceCenter?.google_map_link || "");
    toast.success("Link copied to clipboard!");
    handleLocationClose();
  };

  //review popup
  const [shareReviewOpen, setShareReviewOpen] = useState(null);
  const handleReviewOpen = (event) => setShareReviewOpen(event.currentTarget);
  const handleReviewClose = () => setShareReviewOpen(null);
  const reviewOpen = Boolean(shareReviewOpen);
  const handleReviewWhatsApp = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(
      `Check this link: ${userServiceCenter?.google_review_link || ""}`
    )}`;
    window.open(url, "_blank");
    handleReviewClose(false);
  };

  const handleReviewCopyLink = () => {
    navigator.clipboard.writeText(userServiceCenter?.google_review_link || "");
    toast.success("Link copied to clipboard!");
    handleReviewClose(false);
  };

  //today expense
  const [billSummary, setBillSummary] = useState({
    total_amount: 0,
    paid_amount: 0,
    unpaid_amount: 0,
    partial_paid_amount: 0,
    paid_count: 0,
    unpaid_count: 0,
  });

  //shortcuts
  const [addcashFlowModal, setAddCashFlowModal] = useState(false);
  const [addExpenseModal, setAddExpenseModal] = useState(false);

  const handleToggleCashFlowModal = () => {
    setAddCashFlowModal(!addcashFlowModal);
  };
  const handleToggleExpenseModal = () => {
    setAddExpenseModal(!addExpenseModal);
  };

  //daily report pop up
  const [sharePopupAnchorEl, setSharePopupAnchorEl] = useState(null);
  const handleSharePopupOpen = (event) => {
    setSharePopupAnchorEl(event.currentTarget);
    setSummaryParam({ date: format(new Date(), "yyyy-MM-dd") });
  };

  const handleSharePopupClose = () => {
    setSharePopupAnchorEl(null);
    setOpenSpeedDial(false);
    setReportSummary("");
  };
  const sharePopupOpen = Boolean(sharePopupAnchorEl);
  const [openSpeedDial, setOpenSpeedDial] = useState(false);
  const actions = [
    {
      icon: <FaWhatsapp color="#25D366" />,
      name: "WhatsApp",
      onClick: () =>
        window.open(
          `https://wa.me/918455081525?text=${encodeURIComponent(
            reportSummary?.replace(/\u00A0/g, " ")
          )}`,
          "_blank"
        ),
    },
    {
      icon: <FaEnvelope color="#EA4335" />,
      name: "Email",
      onClick: () =>
        window.open(
          `mailto:?subject=Today’s Accounting&body=${reportSummary}`,
          "_blank"
        ),
    },
    {
      icon: <FaCopy />,
      name: "Copy",
      onClick: () => {
        navigator.clipboard.writeText(reportSummary);
        toast.success("Coppied");
      },
    },
  ];

  const whatsAppReport = () => {
    setReportSummaryLoading(true);
    getWhatsAppReportDashboardApi(summaryParam?.date)
      .then((res) => {
        setReportSummary(res?.data?.message);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setReportSummaryLoading(false);
      });
  };

  const getTodayBillingApi = () => {
    getUserTodayBillibgDashboardApi()
      .then((res) => {
        const data = res?.data?.results?.overall_summary;
        setBillSummary({
          total_amount: data?.total_amount || 0,
          paid_amount: data?.payment_received || 0,
          unpaid_amount: data?.total_outstanding || 0,
          partial_paid_amount: data?.partially_paid_amount || 0,
          paid_count: data?.paid_count || 0,
          unpaid_count: data?.unpaid_count || 0,
          total_count: data?.total_billings || 0,
          partial_paid_count: data?.partially_paid_count || 0,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getUserServiceCenter = () => {
    getUserServicecenterDeatailsApi()
      .then((res) => {
        setUserServiceCenter(res?.data?.results || null);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  useEffect(() => {
    getTodayBillingApi();
    getUserServiceCenter();
  }, []);

  useEffect(() => {
    if (sharePopupOpen) {
      whatsAppReport();
    }
  }, [summaryParam, sharePopupOpen]);
  return (
    <div className="container-fluid p-0">
      <div className="mb-4">
        <div className="card shadow-sm border-0 rounded-3">
          <div className="card-body">
            <div className="row align-items-center g-3">
              <div className="col-md-6 col-lg-5 d-flex align-items-center">
                <div className="me-3 p-3 rounded-3 text-bg-primary-soft d-flex align-items-center justify-content-center">
                  <FaMapMarkerAlt size={28} />
                </div>
                <div>
                  <h5 className="mb-1 text-capitalize fw-bold">
                    {userServiceCenter?.name || ""}
                  </h5>
                  <div className="d-flex flex-wrap text-darker small">
                    <span className="me-3">
                      <strong>Total Cash:</strong>{" "}
                      {`₹${formatToIndianNumber(
                        userServiceCenter?.total_cash || 0
                      )}`}
                    </span>
                    <span className="me-2">
                      <strong>Petty Cash:</strong>
                      {`₹${formatToIndianNumber(
                        userServiceCenter?.total_petty_cash || 0
                      )}`}
                    </span>

                    <div
                      className={`btn-group align-self-start p-0 shadow-sm ${
                        isMobile ? "rounded-3" : ""
                      }`}
                    >
                      <CustomTooltip title="Share Location">
                        <button
                          className={`btn btn-outline-light ${
                            isMobile ? "rounded-start-3" : ""
                          }`}
                          style={{
                            padding: isMobile ? "0.1rem 0.3rem" : "0.3rem",
                          }}
                          onClick={handleLocationOpen}
                        >
                          <FaMapMarkerAlt size={isMobile ? "10" : "13"} />
                          {isMobile && (
                            <span
                              className="text-dark fw-medium ms-1"
                              style={{ fontSize: "0.6rem" }}
                            >
                              Location
                            </span>
                          )}
                        </button>
                      </CustomTooltip>
                      <CustomTooltip title="Share Review Link">
                        <button
                          className={`btn btn-outline-light ${
                            isMobile ? "rounded-end-3" : ""
                          }`}
                          style={{
                            padding: isMobile ? "0.1rem 0.3rem" : "0.3rem",
                          }}
                          onClick={handleReviewOpen}
                        >
                          <MdFeedback size={isMobile ? "10" : "13"} />
                          {isMobile && (
                            <span
                              className="text-dark fw-medium ms-1"
                              style={{ fontSize: "0.6rem" }}
                            >
                              Review
                            </span>
                          )}
                        </button>
                      </CustomTooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-7">
                <div className="d-flex flex-wrap gap-2 justify-content-md-end ">
                  <button
                    className="btn btn-outline-primary rounded-pill d-flex align-items-center shadow-sm"
                    onClick={handleSharePopupOpen}
                    style={{ padding: "0.4rem 0.85rem" }}
                  >
                    <LuShare2 size={16} className="me-1" />
                    Reports Summary
                  </button>

                  <Link
                    to="/bill-add"
                    className="btn btn-primary rounded-pill d-flex align-items-center shadow-sm"
                    style={{ padding: "0.4rem 0.85rem" }}
                  >
                    <MdAdd size={16} className="me-1" />
                    Add Bill
                  </Link>

                  <button
                    className="btn btn-primary rounded-pill d-flex align-items-center shadow-sm"
                    onClick={handleToggleExpenseModal}
                    style={{ padding: "0.4rem 0.85rem" }}
                  >
                    <MdAdd size={16} className="me-1" />
                    Add Expense
                  </button>

                  <button
                    className="btn btn-primary rounded-pill d-flex align-items-center shadow-sm"
                    onClick={handleToggleCashFlowModal}
                    style={{ padding: "0.4rem 0.85rem" }}
                  >
                    <MdAdd size={16} className="me-1" />
                    Add Cashflow
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`row ${isMobile ? "g-1" : "g-3"}`}>
        <div className="col-3">
          <div
            className={`card shadow-sm overflow-hidden h-100 ${
              isMobile ? "rounded-2" : "rounded-4"
            }`}
            style={{
              background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
          >
            {/* Decorative Gradient Orbs */}
            <div
              style={{
                position: "absolute",
                top: "-15%",
                right: "-15%",
                width: "140px",
                height: "140px",
                background:
                  "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 197, 253, 0.1))",
                borderRadius: "50%",
                filter: "blur(50px)",
                opacity: "0.7",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-20%",
                left: "-20%",
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(147, 197, 253, 0.08))",
                borderRadius: "50%",
                filter: "blur(40px)",
                opacity: "0.5",
                pointerEvents: "none",
              }}
            ></div>

            {/* Subtle Border Accent */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background: "linear-gradient(90deg, #3b82f6, #60a5fa)",
                borderRadius: "4px 4px 0 0",
              }}
            ></div>

            <div
              className={`card-body d-flex align-items-center justify-content-between position-relative ${
                isMobile ? "p-2" : "p-4"
              }`}
            >
              {/* Left Section: Value and Label */}
              <div className="d-flex flex-column">
                <h4
                  className="mb-1 fw-bold"
                  style={{
                    fontSize: isMobile ? "0.8rem" : "1.25rem",
                    color: "#1e3a8a",
                    letterSpacing: "-0.025em",
                  }}
                >
                  ₹{formatToIndianNumber(billSummary?.total_amount || 0)}
                </h4>
                <p
                  className="mb-0 text-gray-600 fw-medium"
                  style={{
                    fontSize: isMobile ? "0.53rem" : "0.85rem",
                    lineHeight: "1.4",
                  }}
                >
                  Sell Amount
                </p>
              </div>

              {/* Right Section: Icon with Gradient Background */}
              <div
                className="d-none d-md-flex align-items-center justify-content-center rounded-circle"
                style={{
                  padding: "0.75rem",
                  background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
                  color: "white",
                  boxShadow: "0 6px 15px rgba(59, 130, 246, 0.3)",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <MdOutlineAssessment size={25} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-3">
          <div
            className={`card shadow-sm overflow-hidden h-100 ${
              isMobile ? "rounded-2" : "rounded-4"
            }`}
            style={{
              background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
          >
            {/* Decorative Gradient Orbs */}
            <div
              style={{
                position: "absolute",
                top: "-15%",
                right: "-15%",
                width: "140px",
                height: "140px",
                background:
                  "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(187, 247, 208, 0.1))",
                borderRadius: "50%",
                filter: "blur(50px)",
                opacity: "0.7",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-20%",
                left: "-20%",
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(187, 247, 208, 0.08))",
                borderRadius: "50%",
                filter: "blur(40px)",
                opacity: "0.5",
                pointerEvents: "none",
              }}
            ></div>
            {/* Border Accent */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background: "linear-gradient(90deg, #22c55e, #86efac)",
                borderRadius: "4px 4px 0 0",
              }}
            ></div>
            <div
              className={`card-body d-flex align-items-center justify-content-between position-relative ${
                isMobile ? "p-2" : "p-4"
              }`}
            >
              <div className="d-flex flex-column">
                <h4
                  className="mb-1 fw-bold"
                  style={{
                    fontSize: isMobile ? "0.8rem" : "1.25rem",
                    // color: "#1e3a8a",
                    color: "#14532d",
                    letterSpacing: "-0.025em",
                  }}
                >
                  ₹{formatToIndianNumber(billSummary?.paid_amount || 0)}
                </h4>
                <p
                  className="mb-0 text-gray-600 fw-medium"
                  style={{
                    fontSize: isMobile ? "0.6rem" : "0.85rem",
                    lineHeight: "1.4",
                  }}
                >
                  Paid ({billSummary?.paid_count || 0})
                </p>
              </div>
              <div
                className="d-none d-md-flex align-items-center justify-content-center rounded-circle"
                style={{
                  padding: "0.75rem",
                  background: "linear-gradient(135deg, #22c55e, #86efac)",
                  color: "white",
                  boxShadow: "0 6px 15px rgba(34, 197, 94, 0.3)",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <FaCheckCircle size={25} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-3">
          <div
            className={`card shadow-sm overflow-hidden h-100 ${
              isMobile ? "rounded-2" : "rounded-4"
            }`}
            style={{
              background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
          >
            {/* Decorative Gradient Orbs */}
            <div
              style={{
                position: "absolute",
                top: "-15%",
                right: "-15%",
                width: "140px",
                height: "140px",
                background:
                  "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(254, 202, 202, 0.1))",
                borderRadius: "50%",
                filter: "blur(50px)",
                opacity: "0.7",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-20%",
                left: "-20%",
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(254, 202, 202, 0.08))",
                borderRadius: "50%",
                filter: "blur(40px)",
                opacity: "0.5",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background: "linear-gradient(90deg, #ef4444, #f87171)",
                borderRadius: "4px 4px 0 0",
              }}
            ></div>
            <div
              className={`card-body d-flex align-items-center justify-content-between position-relative ${
                isMobile ? "p-2" : "p-4"
              }`}
            >
              <div className="d-flex flex-column">
                <h4
                  className="mb-1 fw-bold text-primary"
                  style={{
                    fontSize: isMobile ? "0.8rem" : "1.25rem",
                    // color: "#1e3a8a",
                    letterSpacing: "-0.025em",
                  }}
                >
                  ₹{formatToIndianNumber(billSummary?.unpaid_amount || 0)}
                </h4>
                <p
                  className="mb-0 fw-medium"
                  style={{
                    fontSize: isMobile ? "0.55rem" : "0.85rem",
                    lineHeight: "1.4",
                  }}
                >
                  Outstanding ({billSummary?.unpaid_count || 0})
                </p>
              </div>
              <div
                className="d-none d-md-flex align-items-center justify-content-center rounded-circle"
                style={{
                  padding: "0.75rem",
                  background: "linear-gradient(135deg, #ef4444, #f87171)",
                  color: "white",
                  boxShadow: "0 6px 15px rgba(239, 68, 68, 0.3)",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <IoIosWarning size={23} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-3">
          <div
            className={`card shadow-sm overflow-hidden h-100 ${
              isMobile ? "rounded-2" : "rounded-4"
            }`}
            style={{
              background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 10px 20px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
          >
            {/* Decorative Gradient Orbs */}
            <div
              style={{
                position: "absolute",
                top: "-15%",
                right: "-15%",
                width: "140px",
                height: "140px",
                background:
                  "linear-gradient(135deg, rgba(234, 179, 8, 0.15), rgba(254, 243, 199, 0.1))",
                borderRadius: "50%",
                filter: "blur(50px)",
                opacity: "0.7",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-20%",
                left: "-20%",
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(234, 179, 8, 0.12), rgba(254, 243, 199, 0.08))",
                borderRadius: "50%",
                filter: "blur(40px)",
                opacity: "0.5",
                pointerEvents: "none",
              }}
            ></div>
            {/* Border Accent */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "4px",
                background: "linear-gradient(90deg, #eab308, #fde047)",
                borderRadius: "4px 4px 0 0",
              }}
            ></div>
            <div
              className={`card-body d-flex align-items-center justify-content-between position-relative ${
                isMobile ? "p-2" : "p-4"
              }`}
            >
              <div className="d-flex flex-column">
                <h4
                  className="mb-1 fw-bold"
                  style={{
                    fontSize: isMobile ? "0.8rem" : "1.25rem",
                    // color: "#1e3a8a",
                    color: "#713f12",
                    letterSpacing: "-0.025em",
                  }}
                >
                  ₹{formatToIndianNumber(billSummary?.partial_paid_amount || 0)}
                </h4>
                <p
                  className="mb-0 text-gray-600 fw-medium"
                  style={{
                    fontSize: isMobile ? "0.53rem" : "0.85rem",
                    lineHeight: "1.4",
                  }}
                >
                  Partially Paid
                </p>
              </div>
              <div
                className="d-none d-md-flex align-items-center justify-content-center rounded-circle"
                style={{
                  padding: "0.75rem",
                  background: "linear-gradient(135deg, #eab308, #fde047)",
                  color: "white",
                  boxShadow: "0 6px 15px rgba(234, 179, 8, 0.3)",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <FaRecycle size={25} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-md-4">
          <UserTimeChart />
        </div>
        <div className="col-md-4">
          <UserServiceTypeChart />
        </div>
        <div className="col-md-4">
          <SpecificVehicleTypeChart />
        </div>
      </div>

      {/* share popup */}
      <Popover
        open={sharePopupOpen}
        anchorEl={sharePopupAnchorEl}
        onClose={handleSharePopupClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            p: 1,
            boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
            borderRadius: "8px",
            width: {
              xs: "90vw",
            },
            minWidth: { sm: "300px" },
            maxWidth: { sm: "350px" },
          },
        }}
      >
        <div>
          <div className="d-flex align-items-center gap-1 justify-content-between my-1">
            <h5>Reports</h5>
            <div className="position-relative">
              <style>
                {`
      .react-datepicker__input-container input {
        font-size: 0.65rem !important;
        height: 31px !important;
        padding-right: 2rem !important; /* space for the icon */
      }
      .react-datepicker__close-icon::after {
        font-size: 9px !important;
        line-height: 9px !important;
        width: 13px !important;
        height: 9px !important;
      }
    `}
              </style>

              <DatePicker
                selected={
                  summaryParam?.date ? new Date(summaryParam.date) : null
                }
                onChange={(date) => {
                  setSummaryParam((prev) => ({
                    ...prev,
                    date: date ? format(date, "yyyy-MM-dd") : "",
                  }));
                }}
                placeholderText="Select date"
                className="form-control"
              />
              <FiCalendar
                className="position-absolute top-50 end-0 translate-middle-y me-2 text-secondary"
                style={{ fontSize: "0.9rem", pointerEvents: "none" }}
              />
            </div>
          </div>

          {reportSummaryLoading ? (
            <div className="my-3 text-center">
              <Spinner animation="border" size="sm" />
            </div>
          ) : reportSummary ? (
            <div
              className="mb-2 scroll-container"
              style={{
                maxHeight: "350px",
                whiteSpace: "pre-wrap",
                fontFamily: "monospace",
                overflowY: "scroll",
              }}
            >
              {reportSummary}
            </div>
          ) : (
            <div className="text-center my-2">No data found</div>
          )}
          {reportSummary && !reportSummaryLoading && (
            <Box sx={{ position: "absolute", bottom: 16, right: 16 }}>
              <SpeedDial
                ariaLabel="Share Options"
                icon={openSpeedDial ? <FaTimes /> : <FaShareAlt />}
                open={openSpeedDial}
                direction="left"
                FabProps={{
                  onClick: () => setOpenSpeedDial((prev) => !prev),
                  size: "small",
                  sx: {
                    bgcolor: "#d65e1c",
                    "&:hover": { bgcolor: "#d65e1c" },
                  },
                }}
              >
                {actions.map((action) => (
                  <SpeedDialAction
                    key={action.name}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    onClick={() => {
                      action.onClick();
                      setOpenSpeedDial(false);
                    }}
                  />
                ))}
              </SpeedDial>
            </Box>
          )}
        </div>
      </Popover>

      <AddCashFlowModal
        visible={addcashFlowModal}
        onClose={handleToggleCashFlowModal}
        onAfterSubmit={handleToggleCashFlowModal}
      />
      <AddExpenseModal
        visible={addExpenseModal}
        onClose={handleToggleExpenseModal}
        onAfterSubmit={handleToggleExpenseModal}
      />
      <Menu
        anchorEl={shareLoactionOpen}
        open={locationOpen}
        onClose={handleLocationClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: "6px", // lighter radius
            padding: "0.15rem 0",
            minWidth: "130px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)", // very light shadow
          },
        }}
      >
        <MenuItem
          onClick={handleLocationCopyLink}
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
        >
          <ListItemIcon>
            <FaLink />
          </ListItemIcon>
          Copy Link
        </MenuItem>
        <MenuItem
          onClick={handleLocationWhatsApp}
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
        >
          <ListItemIcon>
            <FaWhatsapp className="text-success" />
          </ListItemIcon>
          Share In WhatsApp
        </MenuItem>
      </Menu>
      <Menu
        anchorEl={shareReviewOpen}
        open={reviewOpen}
        onClose={handleReviewClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: "6px", // lighter radius
            padding: "0.15rem 0",
            minWidth: "130px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)", // very light shadow
          },
        }}
      >
        <MenuItem
          onClick={handleReviewCopyLink}
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
        >
          <ListItemIcon>
            <FaLink />
          </ListItemIcon>
          Copy Link
        </MenuItem>
        <MenuItem
          onClick={handleReviewWhatsApp}
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
        >
          <ListItemIcon>
            <FaWhatsapp className="text-success" />
          </ListItemIcon>
          Share In WhatsApp
        </MenuItem>
      </Menu>
    </div>
  );
};

export default UserDashboard;
